// Import styles
import '../styles/main.scss';
import { Header } from './sections/header.js';
import { Hero } from './sections/hero.js';
import { Services, animateServicesList } from './sections/services.js';
import { Space } from './sections/space.js';
import { Team, enableTeamSlider } from './sections/team.js';
import { Footer } from './sections/footer.js';
import { PrivacyPolicy } from './sections/privacy-policy.js';

// Funzione per renderizzare il contenuto della home page
function renderHomePage() {
  return `
    <div class="loader">
      <div class="loader__spinner"></div>
    </div>
    <div class="content">
      ${Header()}
      ${Hero()}
      ${Services()}
      ${Space()}
      ${Team()}
      ${Footer()}
    </div>
  `;
}

// Funzione per renderizzare la pagina privacy policy
function renderPrivacyPage() {
  return `
    <div class="loader">
      <div class="loader__spinner"></div>
    </div>
    <div class="content">
      ${Header()}
      ${PrivacyPolicy()}
      ${Footer()}
    </div>
  `;
}

// Funzione per renderizzare il contenuto in base al path
function renderContent(path) {
  if (path === '/privacy-policy') {
    return renderPrivacyPage();
  }
  return renderHomePage();
}

// Funzione per navigare a una nuova pagina
function navigateTo(path) {
  const app = document.getElementById('app');
  const content = renderContent(path);
  app.innerHTML = content;
  
  // Aggiorna l'URL usando hash per evitare problemi di ricaricamento
  window.location.hash = path;
  
  // Scrolla in cima alla pagina
  window.scrollTo({ top: 0 });
  
  // Inizializza la nuova pagina
  initializePage(path);
}

// Funzione per inizializzare gli elementi della pagina
function initializePage(path = '/') {
  // Rimuovi il loader
  setTimeout(() => {
    const loader = document.querySelector('.loader');
    if (loader) loader.remove();
    const app = document.getElementById('app');
    app.classList.add('loaded');
  }, 100);

  // Inizializza elementi solo per la home page
  if (path === '/') {
    // Applica blur/placeholder alla hero finché non è caricata
    const heroSection = document.querySelector('.hero');
    if (heroSection) heroSection.classList.add('loading');

    // Precarica l'immagine hero con priorità alta
    const heroImage = new Image();
    heroImage.fetchPriority = 'high';
    heroImage.src = '/images/forma-studio-hero.webp';
    heroImage.onload = function() {
      if (heroSection) heroSection.classList.remove('loading');
    };
    heroImage.onerror = function() {
      if (heroSection) heroSection.classList.remove('loading');
    };

    // Inizializza gli slider e le animazioni
    enableSliderDrag();
    enableTeamSlider();
    animateServicesList();

    // Precarica in background le immagini dei servizi
    const serviceImages = [
      '/images/services/personal-training-one-to-one.webp',
      '/images/services/personal-training-one-to-two.webp',
      '/images/services/pilates-reformer-one-to-one.webp',
      '/images/services/pilates-reformer-one-to-two.webp',
      '/images/services/coaching-online.webp',
      '/images/services/fisioterapia.webp',
      '/images/services/nutrizione.webp'
    ];
    // Precarica le immagini dei servizi con priorità alta
    const preloadedImages = new Set();
    serviceImages.forEach(src => {
      const img = new Image();
      img.fetchPriority = 'high';
      img.onload = () => preloadedImages.add(src);
      img.src = src;
    });
  }
}

// Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
  const app = document.getElementById('app');
  
  // Funzione per ottenere il path corrente (dall'hash o dal pathname)
  function getCurrentPath() {
    const hash = window.location.hash.slice(1); // Rimuovi il #
    return hash || window.location.pathname;
  }
  
  // Ottieni il path corrente
  const currentPath = getCurrentPath();
  
  // Prepara il contenuto iniziale
  const content = renderContent(currentPath);
  app.innerHTML = content;
  
  // Inizializza la pagina corrente
  initializePage(currentPath);
  
  // Gestisci i cambiamenti dell'hash
  window.addEventListener('hashchange', () => {
    const path = getCurrentPath();
    const content = renderContent(path);
    app.innerHTML = content;
    
    // Scrolla in cima alla pagina
    window.scrollTo({ top: 0 });
    
    initializePage(path);
  });
  
  // Gestisci i click sui link interni
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (link && link.href.startsWith(window.location.origin)) {
      const url = new URL(link.href);
      const path = url.pathname;
      
      // Se è un link interno e non è già sulla stessa pagina
      if (path !== window.location.pathname) {
        event.preventDefault();
        navigateTo(path);
      }
    }
  });
});

export function enableSliderDrag() {
  const sliders = document.querySelectorAll('.slider');
  if (!sliders.length) return;

  sliders.forEach(slider => {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });

    const controls = document.querySelectorAll('.slider-controls');
    if (controls.length === 2) {
      const [leftArrow, rightArrow] = controls;
      const scrollAmount = slider.querySelector('img')?.offsetWidth || 400;

      leftArrow.addEventListener('click', () => {
        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      rightArrow.addEventListener('click', () => {
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  });
}